import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import { SessionController } from '../auth/session/session-controller';
import { AccountService } from '../shared/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class ChatAgentGuard implements CanActivate {
  constructor(
    private readonly _accountService: AccountService,
    private readonly _session: SessionController
  ) {}

  public canActivate(): Observable<boolean> {
    return this._session.isAuthenticated$.pipe(
      filter(authenticated => authenticated),
      switchMap(() => this._accountService.isAgent())
    );
  }
}
